import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { useMemo, type ReactNode } from 'react';

declare global {
  interface Window {
    __CSP_NONCE__?: string;
  }
}

type EmotionCacheProviderProps = {
  children: ReactNode;
};

export function EmotionCacheProvider({ children }: EmotionCacheProviderProps) {
  const cache = useMemo(
    () =>
      createCache({
        key: 'mui',
        // Create during render so main.tsx has already generated the CSP nonce.
        nonce: window.__CSP_NONCE__,
        prepend: true,
      }),
    []
  );

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}
